import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Slash({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'22px'} height={'22px'} viewBox={'0 0 22 22'}>
        <g strokeWidth={'1'} className={'icon__fill'} fillRule={'evenodd'}>
          <g transform={'translate(-1.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M4.22289322,5.63710678 C3.83236893,5.24658249 3.83236893,4.61341751 4.22289322,4.22289322 C4.61341751,3.83236893 5.24658249,3.83236893 5.63710678,4.22289322 L19.7771068,18.3628932 C20.1676311,18.7534175 20.1676311,19.3865825 19.7771068,19.7771068 C19.3865825,20.1676311 18.7534175,20.1676311 18.3628932,19.7771068 L4.22289322,5.63710678 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Slash.propTypes = {
  className: PropTypes.string,
}
